import { create } from 'zustand';

interface OTPState {
  cognitoUser: any;
  setCognitoUser: (user: any) => void;
  clearCognitoUser: () => void;
}

export const useOTPStore = create<OTPState>((set) => ({
  cognitoUser: null,
  setCognitoUser: (user) => set({ cognitoUser: user }),
  clearCognitoUser: () => set({ cognitoUser: null }),
}));
